export const BUSINESS_UNIT_DATA = 'businessUnitData';
export const CURRENT_BUSINESS_UNIT_ID = 'currentBusinessUnitId';
export const STATUS = 'status';
export const DEFAULT_ACCOUNT_BUSINESS_UNIT_ID = 0;
export const ALL_BUSINESS_UNIT_ID = -1; // only used for display purposes
export const LOGO_URL = 'logoUrl';
export const RESIZED_LOGO_URL = 'resizedUrl';